import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    alpha,
    styled,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast'
import { ReactComponent as IosInstallSvg } from '../../assets/images/ios-install.svg'
import { ReactComponent as IosShareIcon } from '../../assets/Ei-share-apple.svg'

interface IBeforeInstallPromptEvent extends Event {
    readonly platforms: string[]
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed'
        platform: string
    }>
    prompt(): Promise<void>
}

const Container = styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: 0,
    right: 0,
    width: '100%',
    background: alpha(theme.palette.background.paper, 0.8),
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 3),
    alignItems: 'center',
    height: 48,
}))

const IconBox = styled(Box)(() => ({
    height: 32,
    display: 'inline-block',
    '& svg': {
        height: '100%',
    },
}))

export default function InstallPrompt(): JSX.Element {
    const [prompt, setPrompt] = useState<IBeforeInstallPromptEvent>()

    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase()
        return /iphone|ipad|ipod/.test(userAgent)
    }

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault()
            setPrompt(e as IBeforeInstallPromptEvent)
        })
    }, [])

    const handleInstall = () => {
        if (prompt) {
            prompt.prompt()

            prompt.userChoice.then((choiseResult) => {
                if (choiseResult.outcome === 'accepted') {
                    toast.success('برنامه با موفقیت نصب شد')
                }

                setPrompt(undefined)
            })
        }
    }

    if (isIos()) {
        return (
            <Dialog
                dir="rtl"
                open={isIos()}
                keepMounted
                aria-describedby="install-ios"
                sx={{ zIndex: 10000 }}
            >
                <DialogTitle>نصب برنامه</DialogTitle>
                <DialogContent>
                    <IosInstallSvg />

                    <Typography variant="body2">
                        گزینه{' '}
                        <IconBox>
                            <IosShareIcon />
                        </IconBox>{' '}
                        را کلیک و گزینه Add to Home Screen را انتخاب کنید
                    </Typography>
                </DialogContent>
            </Dialog>
        )
    }

    return (
        <Dialog
            fullWidth
            maxWidth="xs"
            dir="rtl"
            open
            keepMounted
            aria-describedby="install-ios"
            sx={{ zIndex: 10000 }}
        >
            <DialogTitle>نصب برنامه</DialogTitle>
            <DialogContent>
                <IosInstallSvg />

                <Typography variant="body2">
                    برای استفاده بهتر از برنامه آن را نصب کنید
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    mb: 1,
                }}
            >
                <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={handleInstall}
                >
                    نصب برنامه
                </Button>
            </DialogActions>
        </Dialog>
    )
}
